module.exports = __webpack_public_path__ + "img/aboutusbg.cb8a42ef.png";